import {
  CHAT_BOT_ATTRIBUTES,
  CHAT_LOADER_SRC,
  CHAT_LOAD_TIMEOUT_MS,
} from "../../domain/chat/widget";

const createChatBot = () => {
  const chatBot = document.createElement("chat-bot");
  Object.entries(CHAT_BOT_ATTRIBUTES).forEach(([name, value]) =>
    chatBot.setAttribute(name, value),
  );
  return chatBot;
};

const createLoaderScript = () => {
  const script = document.createElement("script");
  script.src = CHAT_LOADER_SRC;
  script.async = true;
  return script;
};

export const findChatBot = () => document.querySelector("chat-bot");

const findLoaderScript = () =>
  document.querySelector(`script[src="${CHAT_LOADER_SRC}"]`);

// Removing <chat-bot> runs the vendor's disconnectedCallback, which tears the widget down.
const ensureChatBot = () =>
  findChatBot() ?? document.body.appendChild(createChatBot());

const ensureLoaderScript = () =>
  findLoaderScript() ?? document.body.appendChild(createLoaderScript());

const loadFailure = (script) =>
  new Promise((_, reject) => {
    script.addEventListener(
      "error",
      () => {
        script.remove();
        reject(new Error("Chat loader script failed to load"));
      },
      { once: true },
    );
  });

const timeout = (ms) =>
  new Promise((_, reject) => {
    setTimeout(
      () => reject(new Error(`Chat widget not defined after ${ms} ms`)),
      ms,
    );
  });

export const loadChatWidget = () => {
  ensureChatBot();
  const script = ensureLoaderScript();
  return Promise.race([
    customElements.whenDefined("chat-bot"),
    loadFailure(script),
    timeout(CHAT_LOAD_TIMEOUT_MS),
  ]).then(() => window.chatsimpleWidget.open());
};
